'use client'

import Image from 'next/image'
import {clsx} from 'clsx'
import s from '../../style.module.scss'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {HeaderEvent} from '../../analytics/events'
import CometLink from '@app/components/custom-links/comet-link'

interface Props {
  showPoweredBy: boolean
  logoSource: string
  poweredByLogo: string
  isMobile: boolean
  className?: string
}

const LogoClient = ({showPoweredBy, logoSource, poweredByLogo, isMobile, className}: Props) => {
  return (
    <CometLink
      href='/'
      className={clsx(s.logo_container, className)}
      onClick={() => triggerAnalytics(HeaderEvent.HomeIconClicked).sendAll()}
    >
      <Image
        width={isMobile ? 108 : 120}
        height={isMobile ? 28 : 33}
        alt='Company logo'
        src={logoSource}
        className=' object-contain'
      />

      {showPoweredBy && (
        <>
          <div className={s.divider} />
          <Image
            width={50}
            height={21}
            alt='Powered by Gamezop'
            src={poweredByLogo}
            className={clsx(
              s.nav_logo,
              {
                [s.desktop_nav_logo]: !isMobile,
              },
              'object-contain',
            )}
          />
        </>
      )}
    </CometLink>
  )
}

export default LogoClient
